module.exports = __webpack_public_path__ + "img/frame_bg.93b9a89c.png";